module.exports = __webpack_public_path__ + "img/banner4行业动态.76c6af1a.jpg";